module.exports = __webpack_public_path__ + "static/media/e300c217-b1bc-4b65-a0a9-4819691857d4.7b7568c2.png";